import React from 'react';
import OAuthCallbackPage from './OAuthCallbackPage';

const NotionOAuthCallback: React.FC = () => (
  <OAuthCallbackPage
    provider="notion"
    redirectUri={`${window.location.origin}/auth/notion/callback`}
    loadingText="Connecting to Notion…"
    successTitle="Notion Connected!"
    successBody="Your Notion workspace has been successfully connected."
  />
);

export default NotionOAuthCallback;
